import React, { useState } from "react";
import { DropdownItem, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Contacts from "./Contacts";
import { useSetContactsInLocationMutation } from "../store/slices/mapsSlice";
import ContactLocationMap from "./ContactLocationMap";

export default function BulkAssignLocationModal({
  selectedContacts,
  setFilter,
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [saveContactLocation] = useSetContactsInLocationMutation();
  const [markerOverlay, setMarkerOverlay] = useState();
  const [address, setAddress] = useState("");

  const handleSave = async () => {
    if (markerOverlay) {
      const data = saveContactLocation({
        Lat: markerOverlay.position.lat(),
        Lng: markerOverlay.position.lng(),
        items: selectedContacts,
      });

      if (data.isError) {
        toast.error(data.message);
        return;
      }
      if (data) {
        toast.success("Contacts updated successfully");
        setFilter((p) => [...p]);
      }
    }
  };

  const [showContactSets, setShowContactSets] = useState([]);

  return (
    <>
      <DropdownItem onClick={handleShow}>Edit Location</DropdownItem>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col">
              <div className="mt-3 rounded-3 overflow-hidden">
                <ContactLocationMap
                  setMarkerOverlay={setMarkerOverlay}
                  setAddress={setAddress}
                />
              </div>
            </div>
            <div className="col">
              <div className="my-3 bg-white p-3 rounded-3">
                <div className="row align-items-center">
                  <span className="col-4 small fw-semibold">Address</span>
                  <div className="col text-end">
                    <Form.Control
                      as="textarea"
                      aria-label="address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Contacts
            useSearchOptions
            includeContacts={selectedContacts}
            contactSets={showContactSets}
            fullView={false}
          />
          <Button
            variant=""
            onClick={handleSave}
            className="bg-colored-reverse text-white fw-bold rounded-pill p-2 px-4 float-end"
          >
            Update Location
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
